export const ROLE_MODEL = "role";

const roleModel = {
  name: "",
  organisations: []
};

export default roleModel;
